export default function Projects() {
    return (
        <section class="bg-[#001D21] dark:bg-gray-900 antialiased">
  <div class="max-w-screen-xl px-4 py-8 mx-auto lg:px-6 sm:py-16 lg:py-24">
    <div class="max-w-2xl mx-auto text-center">
      <h2 class="text-3xl font-extrabold leading-tight tracking-tight text-[#FB8569] sm:text-4xl dark:text-white">
        Our work
      </h2>
      <p class="mt-4 text-base font-medium text-[#FB8569]  sm:text-xl dark:text-gray-400">
      The Projects section showcases a collection of various initiatives, developments, or tasks undertaken, providing a comprehensive view of their objectives, progress, and outcomes.
      </p>
    </div>

    <div class="grid grid-cols-1 mt-12 text-center sm:mt-16 gap-x-20 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
      <div class="space-y-4">
        <span
          class="bg-gray-800 text-[#9B99FF] text-xl font-medium inline-flex items-center px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300">
          Task 1
        </span>
        <h3 class="text-2xl font-bold leading-tight text-[#F4FCC0] dark:text-white">
          Guess Dodger
        </h3>
        <p class="text-lg font-normal text-[#FB8569] dark:text-[#FB8569]">
          Flowbite helps you connect with friends, family and communities of people who share your interests.
        </p>
        
      </div>

      <div class="space-y-4">
        <span
          class="bg-gray-800 text-[#9B99FF] text-xl font-medium inline-flex items-center px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300">
          Task 2
        </span>
        <h3 class="text-2xl font-bold leading-tight text-[#F4FCC0] dark:text-[#FB8569]">
          Linear and Logistic regression 
        </h3>
        <p class="text-lg font-normal text-[#FB8569] dark:text-[#FB8569]">
          Flowbite helps you connect with friends, family and communities of people who share your interests.
        </p>
        
      </div>

      <div class="space-y-4">
        <span
          class="bg-gray-800 text-[#9B99FF] text-xl font-medium inline-flex items-center px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300">
          Task 3
        </span>
        <h3 class="text-2xl font-bold leading-tight text-[#F4FCC0] dark:text-[#FB8569]">
          Decision tree
        </h3>
        <p class="text-lg font-normal text-[#FB8569] dark:text-[#FB8569]">
          Flowbite helps you connect with friends, family and communities of people who share your interests.
        </p>
        
      </div>
    </div>
    <div class="flex justify-center items-center h-auto bg-#EEEDEB pt-10">
  <a href="#" class="inline-flex justify-center items-center py-3 px-5 text-xl font-bold text-center text-[#9B99FF] rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900 bg-gray-800 shadow-lg transform transition-transform duration-300 hover:scale-105">
    Learn more
    <svg class="ml-2 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path>
    </svg>
  </a>
</div>
  </div>
</section>
    )
}